import { inject } from '@angular/core';
import {
  CanMatchFn,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { first, map, Observable } from 'rxjs';

export const canMatchAuthGuard: CanMatchFn = (
  _route: Route,
  _segments: UrlSegment[],
): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();
  let url = '/';
  if (navigation) {
    url = navigation.extractedUrl.toString();
  }
  return authService.isAuthenticated$.pipe(
    first(),
    map((isAuth) => {
      if (!isAuth) {
        const queryParams = { redirect: url };
        return router.createUrlTree(['/'], { queryParams });
      }
      return true;
    }),
  );
};
